const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
const SIDEBAR_COLLAPSED_COOKIE_NAME = 'onsiteCalendar.sidebarCollapsed';
const PRODUCTION_ZONE_COOKIE_NAME = 'onsiteCalendar.production.selectedZoneId';

function readCookie(cookieName: string): string | null {
  const cookiePrefix = `${cookieName}=`;
  const cookie = document.cookie
    .split('; ')
    .find((cookiePart) => cookiePart.startsWith(cookiePrefix));

  return cookie ? cookie.slice(cookiePrefix.length) : null;
}

function writeCookie(cookieName: string, value: string): void {
  document.cookie = [
    `${cookieName}=${value}`,
    `max-age=${COOKIE_MAX_AGE_SECONDS}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

export function loadSidebarCollapsedPreference(): boolean | null {
  const savedValue = readCookie(SIDEBAR_COLLAPSED_COOKIE_NAME);

  if (savedValue === 'true') {
    return true;
  }

  if (savedValue === 'false') {
    return false;
  }

  return null;
}

export function saveSidebarCollapsedPreference(isCollapsed: boolean): void {
  writeCookie(SIDEBAR_COLLAPSED_COOKIE_NAME, String(isCollapsed));
}

export function loadSelectedProductionZoneIdPreference(): string | null {
  return readCookie(PRODUCTION_ZONE_COOKIE_NAME);
}

export function saveSelectedProductionZoneIdPreference(productionZoneId: string): void {
  writeCookie(PRODUCTION_ZONE_COOKIE_NAME, productionZoneId);
}
